export default {
  items: [],
  loading: false,
  sort: {
    page: 1,
    column: 'email',
    order: 'ascending',
    limit: 0,
    filter: '',
  },
  total: 0,
};
